"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLocale = exports.CHANGE_LOCALE = exports.fetchTranslationsFailure = exports.fetchTranslationsSuccess = exports.fetchTranslationsRequest = exports.FETCH_TRANSLATIONS_FAILURE = exports.FETCH_TRANSLATIONS_SUCCESS = exports.FETCH_TRANSLATIONS_REQUEST = void 0;

var typesafe_actions_1 = require("typesafe-actions"); // Fetch translations


exports.FETCH_TRANSLATIONS_REQUEST = '[Request] Fetch Translations';
exports.FETCH_TRANSLATIONS_SUCCESS = '[Success] Fetch Translations';
exports.FETCH_TRANSLATIONS_FAILURE = '[Failure] Fetch Translations';

var fetchTranslationsRequest = function fetchTranslationsRequest(locale) {
  return typesafe_actions_1.action(exports.FETCH_TRANSLATIONS_REQUEST, {
    locale: locale
  });
};

exports.fetchTranslationsRequest = fetchTranslationsRequest;

var fetchTranslationsSuccess = function fetchTranslationsSuccess(locale, translations) {
  return typesafe_actions_1.action(exports.FETCH_TRANSLATIONS_SUCCESS, {
    locale: locale,
    translations: translations
  });
};

exports.fetchTranslationsSuccess = fetchTranslationsSuccess;

var fetchTranslationsFailure = function fetchTranslationsFailure(error) {
  return typesafe_actions_1.action(exports.FETCH_TRANSLATIONS_FAILURE, {
    error: error
  });
};

exports.fetchTranslationsFailure = fetchTranslationsFailure; // Change locale

exports.CHANGE_LOCALE = 'Change locale';

var changeLocale = function changeLocale(locale) {
  return typesafe_actions_1.action(exports.CHANGE_LOCALE, {
    locale: locale
  });
};

exports.changeLocale = changeLocale;